export const RATE_FIELDS = [
  { key: "mortgages", label: "Mortgages", type: "percentage" },
  { key: "equityRelease", label: "Equity Release", type: "percentage" },
  { key: "protection", label: "Protection", type: "percentage" },
  { key: "gi", label: "GI", type: "percentage" },
  { key: "investments", label: "Investments", type: "percentage" },
  { key: "pensions", label: "Pensions", type: "percentage" },
  {
    key: "bridgingCommercial",
    label: "Bridging & Commercial",
    type: "percentage",
    defaultValue: 85,
  },
  {
    key: "longTermCare",
    label: "Long Term Care",
    type: "percentage",
    defaultValue: 85,
  },
  { key: "referrals", label: "Referrals", type: "percentage" },
  { key: "monthlyFees", label: "Monthly Fees", type: "number" },
];

export const EMPTY_RATES = RATE_FIELDS.reduce(
  (values, field) => ({ ...values, [field.key]: "" }),
  {},
);

export const normaliseRates = (rates = {}) =>
  RATE_FIELDS.reduce((values, field) => {
    const savedValue = rates[field.key];
    const isMissing =
      savedValue === null ||
      savedValue === undefined ||
      (field.defaultValue !== undefined && savedValue === "");

    return {
      ...values,
      [field.key]: isMissing ? (field.defaultValue ?? "") : savedValue,
    };
  }, {});

export const formatRateValue = (value, type) => {
  if (value === "" || value === null || value === undefined) return "-";
  if (type !== "percentage") return String(value);

  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);
  return `${number <= 1 ? number * 100 : number}%`;
};
